module.exports = __webpack_public_path__ + "img/3.e80a4272.jpg";